var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalCalorieBurnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#714FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1746 7.45297C12.1235 7.39047 12.0783 7.33443 12.0402 7.28506C11.9931 7.22362 11.9158 7.19335 11.8395 7.20647C11.7632 7.21958 11.7005 7.27392 11.6766 7.34756C11.562 7.69765 11.3876 8.02527 11.1612 8.31589C11.1746 7.48839 11.0106 6.02818 9.81143 5.24172C9.74729 5.1996 9.66519 5.19614 9.59774 5.23271C9.53029 5.26929 9.4884 5.33999 9.48872 5.41672C9.48872 6.09922 9.1231 6.82652 8.48747 7.41152C7.87247 7.97777 6.44351 9.47422 6.4583 11.1319C6.4681 12.2201 6.99122 13.7003 8.3006 14.3973C8.35828 14.4282 8.4271 14.4301 8.48643 14.4026C8.54577 14.3751 8.58874 14.3213 8.60247 14.2573C8.72414 13.8032 8.92462 13.374 9.19476 12.9892C9.48851 12.5176 9.76622 12.0726 9.79164 11.4498C9.79489 11.3683 9.84548 11.2961 9.92105 11.2653C9.99663 11.2344 10.0833 11.2505 10.1427 11.3065C10.8818 12.0021 11.3173 12.9957 11.426 14.199C11.4331 14.2678 11.4739 14.3285 11.5349 14.3612C11.5958 14.3938 11.669 14.3941 11.7302 14.3619C12.6712 13.8592 13.4106 12.9036 13.5285 11.4276C13.6964 9.32735 12.6685 8.06131 12.1746 7.45297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCalorieBurnt);
export default __webpack_public_path__ + "static/media/TotalCalorieBurnt.761430375c6b205c62e7ab6b416f3ef9.svg";
export { ForwardRef as ReactComponent };